import { Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ICollaboratorReport, IFilterCollaboratorReport } from '../data/collaborator-report';
import { CollaboratorReportService, STATUS_FUNCIONARIO_OPTIONS } from '../services/collaborator-report.service';

// Alinhado ao ExportPageSizeCap da card-api: pedir mais do que o backend entrega
// so produziria um Excel truncado sem aviso.
const EXPORT_MAX_PAGE_SIZE = 50000;

@Component({
  selector: 'app-export-collaborator-report',
  templateUrl: './export-collaborator-report.component.html',
  styleUrls: ['./export-collaborator-report.component.scss']
})
export class ExportCollaboratorReportComponent implements OnDestroy {
  @Input() companyOptions: { id: string; name: string }[] = [];
  @Input() currentOrderBy: EOrdenacao = EOrdenacao.AlfabeticaAZ;

  isExporting = false;
  show = false;

  exportCompanyControl = new UntypedFormControl('Todas');
  exportCardStatusControl = new UntypedFormControl('');
  exportCollaboratorStatusControl = new UntypedFormControl('');

  readonly simNaoOptions = [
    { value: '', label: 'Todos' },
    { value: '1', label: 'Sim' },
    { value: '0', label: 'Não' }
  ];

  readonly statusFuncionarioOptions = STATUS_FUNCIONARIO_OPTIONS;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly collaboratorReportService: CollaboratorReportService,
    private readonly toastService: ToastService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  open(): void {
    this.exportCompanyControl.reset('Todas');
    this.exportCardStatusControl.reset('');
    this.exportCollaboratorStatusControl.reset('');
    this.show = true;
  }

  cancel(): void {
    this.show = false;
  }

  confirm(): void {
    this.isExporting = true;

    const filter: IFilterCollaboratorReport = {
      orderBy: Number(this.currentOrderBy),
      pageNumber: 0,
      pageSize: EXPORT_MAX_PAGE_SIZE
    };

    if (this.exportCardStatusControl.value !== null && this.exportCardStatusControl.value !== '') {
      filter.cardStatus = Number(this.exportCardStatusControl.value);
    }
    if (this.exportCompanyControl.value && this.exportCompanyControl.value !== 'Todas') {
      filter.companyName = this.exportCompanyControl.value;
    }
    if (this.exportCollaboratorStatusControl.value !== null && this.exportCollaboratorStatusControl.value !== '') {
      filter.statusFuncionario = Number(this.exportCollaboratorStatusControl.value);
    }

    this.collaboratorReportService
      .getCollaboratorReport(filter)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (res) => {
          const data: ICollaboratorReport[] = res.data ?? [];
          await this.collaboratorReportService.exportXlsx(data, this.exportCompanyControl.value);

          if (data.length >= EXPORT_MAX_PAGE_SIZE) {
            this.toastService.toast(
              `A exportação foi limitada a ${EXPORT_MAX_PAGE_SIZE.toLocaleString('pt-BR')} linhas. Use os filtros para exportar o restante.`,
              EMessageType.Warning
            );
          }

          this.isExporting = false;
          this.show = false;
        },
        error: () => {
          this.isExporting = false;
          this.toastService.toast('Erro ao exportar. Tente novamente.', EMessageType.Error);
        }
      });
  }
}
